import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiResponseData } from "#interfaces/http-response/responses/http-responses";
import { GlobalSearch } from "#interfaces/search/global-search.interface";
import { cleanParams } from "#utils/clean-params/clean-params.helper";
import { HeadersHttpService } from "#utils/http-headers/http-headers.service";
import { environment } from "environments/environment";
import { catchError, Observable, throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GlobalSearchService {
  private readonly baseUrl = environment.baseUrl + "Search/";

  constructor(
    private readonly httpHeaders: HeadersHttpService,
    private readonly httpClient: HttpClient,
  ) {}

  Global(params: {
    term: string;
    projectId: number | null;
    allProjects: boolean;
    take?: number;
  }): Observable<ApiResponseData<GlobalSearch>> {
    return this.httpClient
      .get<ApiResponseData<GlobalSearch>>(this.baseUrl + "Global", {
        headers: this.httpHeaders.getHeadersPrivate({ showModal: false }),
        params: cleanParams({
          Term: params.term,
          ProjectId: params.projectId,
          AllProjects: params.allProjects,
          Take: params.take,
        }),
      })
      .pipe(catchError((err) => throwError(() => err)));
  }
}
